<template>
  <v-select
    class="select"
    :class="{
      select_compact: compact,
      select_error: error
    }"
    :placeholder="placeholder"
    :options="options"
    :reduce="(item) => item.value"
    :value="value"
    :clearable="clearable ?? true"
    :searchable="inputMode"
    :taggable="inputMode"
    @input="onInput"
    @option:selected="onOptionSelected"
    @search="onSearch"
    @close="onClose"
  >
  </v-select>
</template>

<script>
export default {
  props: {
    placeholder: String,
    options: {},
    value: {},
    clearable: Boolean,
    compact: Boolean,
    inputMode: Boolean,
    error: Boolean,
  },
  data() {
    return {
      search: '',
    };
  },
  methods: {
    onSearch(search) {
      this.search = search;
    },
    onInput(value) {
      this.$emit('input', value);
      this.search = '';
    },
    onClose() {
      if (this.inputMode && this.search) {
        this.$emit('input', this.search);
      }
    },
    onOptionSelected(option) {
      if (this.inputMode && option.label) {
        this.$emit('input', option.label);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.select {
  background-color: var(--tertiary-bg);
  border-radius: 2px;
  position: relative;
  min-width: 160px;

  @include notebook {
    font-size: 16px;
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 8px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 5px 0 5px;
    border-color: $text-secondary transparent transparent transparent;
    pointer-events: none;
  }

  &_error {
    border: 1px solid var(--text-error);
    background-color: var(--bg-error);
  }

  &::v-deep {
    .vs__search {
      margin-top: 6px;
      padding-right: 10px !important;
      color: var(--text-primary);

      &::placeholder {
        color: var(--text-primary);
      }

      &,
      &:focus {
        border: none;
      }
    }

    .vs__dropdown-toggle {
      padding-bottom: 10px;
      padding-top: 3px;
      height: 40px;
      border: 1px solid var(--tertiary-accent);
    }

    .vs_search {
      display: none;
    }

    .vs__open-indicator {
      position: absolute;
      opacity: 0;
      right: 5px;
      top: 0;
      height: 100%;
      z-index: 1;
    }

    .vs__clear {
      margin-right: 18px;
      margin-top: 4px;
      fill: $text-secondary;

      @include notebook {
        padding: 10px 8px;
        margin-right: 11px;
      }
    }

    .vs__selected-options {
      position: relative;
      top: 1px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      flex-wrap: nowrap;
    }

    .vs__selected {
      margin-top: 5px;
      position: relative !important;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: var(--text-primary);

      @include notebook {
        margin-top: 3px;
        padding-left: 1px;
      }

      & + .vs__search {
        width: 0px;
        padding: 0;
      }
    }

    .vs__dropdown-menu {
      background-color: var(--bg);
    }

    .vs__dropdown-option {
      padding-left: 8px;
      padding-right: 8px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: var(--text-primary);

      &--highlight,
      &:hover {
        background-color: var(--lighter-primary);
      }
    }
  }

  &_compact {
    &::v-deep {
        .vs__dropdown-toggle {
            padding-bottom: 0px;
            padding-top: 0px;
            height: 32.5px;

            @include notebook {
              height: 35px;
            }
        }

        .vs__selected {
            margin-top: 3px;

          @include notebook {
            margin-top: 4px;
            padding-left: 2px;
          }
        }

        .vs__search {
          margin-top: -2px;

          @include notebook {
            margin-top: -1px;
          }
        }

        .vs__clear {
          margin-top: -1px;
        }
    }
  }
}
</style>
